module.exports = __webpack_public_path__ + "img/revert.3fe2bc78.svg";